$(document).ready(function() {
    // Initialize the first tab and the first FAQ item
    let firstTab = $(".faq-collection-sec .tab").first();
    let firstTabPane = $("#" + firstTab.data("tab"));

    firstTab.addClass("active");
    firstTabPane.addClass("active");
    firstTabPane.find(".faq-item").first().addClass("active").find(".faq-answer").slideDown();

    // Tab click handler
    $(".faq-collection-sec .tab").on("click", function() {
        let selectedTab = $(this);
        let selectedTabPane = $("#" + selectedTab.data("tab"));

        // Remove active state from all tabs and tab-panes
        $(".faq-collection-sec .tab").removeClass("active");
        $(".faq-collection-sec .tab-pane").removeClass("active");
        
        // Add active class to the clicked tab and corresponding tab-pane
        selectedTab.addClass("active");
        selectedTabPane.addClass("active");

        // Close all FAQ answers in the selected tab and reset the active item
        selectedTabPane.find(".faq-item").removeClass("active").find(".faq-answer").slideUp();
        
        // Open the first FAQ item of the selected tab
        selectedTabPane.find(".faq-item").first().addClass("active").find(".faq-answer").slideDown();
    });

    // FAQ question click handler
    $(".faq-collection-sec").on("click", ".faq-question", function() {
        let faqItem = $(this).closest(".faq-item");
        let faqAnswer = faqItem.find(".faq-answer");
        let currentTabPane = faqItem.closest(".tab-pane");

        // Toggle active state and answer visibility
        if (faqItem.hasClass("active")) {
            faqItem.removeClass("active");
            faqAnswer.slideUp();
        } else {
            // Remove active state and hide answers of all other items in the current tab
            currentTabPane.find(".faq-item").removeClass("active").find(".faq-answer").slideUp();
            faqItem.addClass("active");
            faqAnswer.slideDown();
        }
    });
});
